import styles from "./index.module.css";
import VisualizerBanner from "../visualizer-banner";

export default function Marketplace() {
	return (
		<div className={styles.marketplacePage}>
			<div className={styles.marketplaceContainer}>
				<div className={styles.bannerContainer}>
					<VisualizerBanner />
				</div>
				<iframe
					id="verityMarketplaceIframe"
					allow="microphone; clipboard-write *"
					src="https://staging-panorama-api.yuja.com/api/getMarketplace/Verity"
					className={styles.marketplace}
					allowFullScreen
				/>
			</div>
		</div>
	);
}
